<template>
  <div>
    <el-button type="primary" @click="dialog_config.is_show = true">选择落地页</el-button>
    <view-list
      class="mt-10"
      :value="formItem.value"
      view-key="name"
      :is-show-border="true"
    />
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      :append-to-body="true"
    >
      <site-list-select
        v-if="dialog_config.is_show"
        ref="site_list_select_ref"
        :channel-interface="channelInterface"
        :advertiser-id="advertiserId"
        :value="formItem.value"
        :extra-params="extraParams"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_config.is_show = false">取 消</el-button>
        <el-button type="primary" @click="dialog_config.confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    'view-list': () => import('@/components/base/view-list'),
    'site-list-select': () => import('@/components/business/site/site-list-select'),
  },
  props: {
    channelInterface: {
      type: String,
      required: true,
    },
    // 广告主ID
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    formItem: {
      type: Object,
      required: true,
    },
    // 落地页列表接口额外传参
    extraParams: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog_config: {
        is_show: false,
        title: '落地页',
        confirm: async() => {
          const { getAssignSelection } = this.$refs.site_list_select_ref;
          this.formItem.value = await getAssignSelection();
          this.dialog_config.is_show = false;
        },
      },
    };
  },
  methods: {
    /**
     * 删除
     * @param {number} index 数据项下标
     * @returns {void}
     */
    onDel(index) {
      this.value.splice(index, 1);
    },
  },
};
</script>
